/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { BehaviorSubject ,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';

/**
 * @export
 * @class LmsLoaderService
 */
@Injectable()
export class LmsLoaderService {
  private isLoadingBS: BehaviorSubject<Boolean>;
  isLoading: Observable<Boolean>;
  loadingStatus: Boolean = false;

  /**
   * Creates an instance of LmsLoaderService.
   *
   * @memberOf LmsLoaderService
   */
  constructor() {
    const loader = false;
    this.isLoadingBS = <BehaviorSubject<Boolean>>new BehaviorSubject({});
    this.isLoadingBS.next(loader);
    this.isLoading = this.isLoadingBS.asObservable();
  }

  /**
   * @private
   * @param {Boolean} loaderStatus
   *
   * @memberOf LmsLoaderService
   */
  private updateLoaderValue(loaderStatus: Boolean) {
    this.isLoadingBS.next(loaderStatus);
  }

  /**
   * Invoked for show loader
   * @memberOf LmsLoaderService
   */
  showLoader() {
    this.loadingStatus = true;
    this.updateLoaderValue(true);
    this.setResetBodyScroll(true);
  }

  /**
   * Invoked for hide loader.
   * @memberOf LmsLoaderService
   */
  hideLoader() {
    this.loadingStatus = false;
    this.updateLoaderValue(false);
    this.setResetBodyScroll(false);
  }

  /**
   * Check loading status
   * @returns
   * @memberOf LmsLoaderService
   */
  isLoadingStatus() {
    return this.loadingStatus;
  }

  /**
   * @private
   * @param {boolean} isScrollHide
   *
   * @memberOf LmsLoaderService
   */
  private setResetBodyScroll(isScrollHide: boolean) {
    const bodyElem = document.getElementById('lmsApplication');
    if (bodyElem && isScrollHide) {
      bodyElem.setAttribute('class', 'dialogBodyScrollFreeze');
    } else if (bodyElem && !isScrollHide) {
      bodyElem.removeAttribute('class');
    }
  }
}
